import CheckoutItem from "../interfaces/CheckoutItem";
import Event from "../interfaces/Event";
import ListingSource from "../interfaces/ListingSource";
import Performer from "../interfaces/Performer";
import Venue from "../interfaces/Venue";
import { format, parse, isValid } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export const encodeObject = (obj: any) => {
    return btoa(encodeURIComponent(JSON.stringify(obj)));
}

export const getEventUrlParams = (event: Event) => {
    return event.name.toLowerCase().replaceAll(" ", "-").replaceAll("/", "-") + "/" + (event.listingSource == ListingSource.TEVO ? "0" : "1") + "/" + event.tevoEventId
}

export const getPerformerUrlParams = (performer: Performer) => {
    return performer.name.toLowerCase().replaceAll(" ", "-").replaceAll("/", "-") + "/" + performer.tevoPerformerId
}

export const getVenueUrlParams  = (venue: Venue) => {
    return venue.name.toLowerCase().replaceAll(" ", "-").replaceAll("/", "-") + "/" + venue.tevoVenueId
}

export const getCheckoutItemUrlParams = (checkoutItem: CheckoutItem) => {
    const test =  (checkoutItem.listingSource == ListingSource.TEVO ? "0" : "1") + "/" + checkoutItem.eventId + "/" + checkoutItem.selectedQuantity + "/" +  checkoutItem.listingId
    return test
}

export const canBeParsedToInt = (str: string) => {
    const num = parseInt(str, 10);
    return !isNaN(num) && num.toString() === str.trim();
};

export const resizeImage = async (file: File, maxWidth: number): Promise<File> => {
    return new Promise((resolve) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);

        img.onload = () => {
            const canvas = document.createElement('canvas');
            const aspectRatio = img.height / img.width;

            canvas.width = maxWidth;
            canvas.height = maxWidth * aspectRatio;

            const ctx = canvas.getContext('2d');
            ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);

            canvas.toBlob((blob) => {
                if (blob) {
                    const resizedFile = new File([blob], file.name, {
                        type: file.type,
                    });
                    resolve(resizedFile);
                }
            }, file.type);

            URL.revokeObjectURL(img.src);
        };
    });
};

export const decodeObject = (encoding: string) => {
    try {
        return JSON.parse(decodeURIComponent(atob(encoding)));
    } catch {
        return null;
    }
}

export const parseAndFormatDateFromSection = (sectionString: string) => {
    if (!sectionString) {
        return null;
    }

    // Regex for date/time in form Thursday 05/08/2025 @ 06:38 PM or 05/08/2025 @ 06:38 PM
    const datePattern = /(\d{1,2}\/\d{1,2}\/\d{4})\s*@\s*(\d{1,2}:\d{2})\s*(AM|PM)/i;
    const match = sectionString.match(datePattern);

    if (!match) {
        return null;
    }

    // Combine parts into "MM/DD/YYYY HH:MM AM/PM"
    const datePart = match[1]; // "04/23/2025"
    const timePart = match[2]; // "06:38"
    const ampmPart = match[3]; // "PM"
    const parseableString = `${datePart} ${timePart} ${ampmPart}`; // "04/23/2025 06:38 PM"

    const parseFormat = 'MM/dd/yyyy hh:mm a';
    const timeZone = 'America/Los_Angeles';

    try {
        const parsedDate = parse(parseableString, parseFormat, new Date());

        if (!isValid(parsedDate)) {
            return null;
        }

        const isoString = formatInTimeZone(parsedDate, timeZone, "yyyy-MM-dd'T'HH:mm:ssXXX");
        return isoString;

    } catch (error) {
        return null;
    }
};
